import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Plus, FolderPlus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
} from '@/components/ui/dialog';
import { FolderDetails } from '@/types/hierarchicalFolders';
import { FolderHeaderEditable } from './FolderHeaderEditable';
import { VideoGridPremium } from './VideoGridPremium';

interface FolderViewModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  folder: FolderDetails | null;
  onRename: (newName: string) => void;
  onDelete: () => void;
  onNewVideo: () => void;
  onNewFolder: () => void;
}

export function FolderViewModal({
  open,
  onOpenChange,
  folder,
  onRename,
  onDelete,
  onNewVideo,
  onNewFolder,
}: FolderViewModalProps) {
  useLanguage();
  if (!folder) return null;

  // Mock storage data (replace with real data later)
  const storagePercentage = 83;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[95vw] w-[1200px] h-[90vh] p-0 gap-0 overflow-hidden">
        {/* HEADER */}
        <FolderHeaderEditable
          folderName={folder.name}
          videoCount={folder.videos.length}
          onRename={onRename}
          onDelete={onDelete}
          onClose={() => onOpenChange(false)}
        />

        {/* BODY */}
        <div className="flex-1 overflow-y-auto px-8 py-6">
          <VideoGridPremium
            videos={folder.videos}
            onVideoClick={(video) => console.log('Video clicked:', video)}
            onVideoEdit={(video) => console.log('Edit video:', video)}
            onVideoMove={(video) => console.log('Move video:', video)}
            onVideoDuplicate={(video) => console.log('Duplicate video:', video)}
            onVideoDelete={(video) => console.log('Delete video:', video)}
            onVideoStats={(video) => console.log('View stats:', video)}
          />
        </div>

        {/* FOOTER */}
        <div className="border-t border-[#E4E4E7] bg-[#F9FAFB] px-8 py-5">
          <div className="flex items-center justify-between">
            <div className="flex gap-3">
              <Button
                onClick={onNewVideo}
                className="bg-[#4169E1] hover:bg-[#3557C7] text-white font-medium shadow-sm"
              >
                <Plus className="mr-2 h-4 w-4" />
                {translateInterfaceText("Novo Vídeo")}</Button>
              <Button
                variant="outline"
                onClick={onNewFolder}
                className="border-[#E5E7EB] hover:bg-[#F3F4F6]"
              >
                <FolderPlus className="mr-2 h-4 w-4" />
                {translateInterfaceText("Nova Pasta")}</Button>
            </div>

            <div className="flex items-center gap-3">
              <span className="text-sm text-[#6B7280]">
                {translateInterfaceText("Armazenamento:")}{" "}<strong className="text-[#111827]">{storagePercentage}%</strong>
              </span>
              <div className="w-32 h-2 bg-[#E5E7EB] rounded-full overflow-hidden">
                <div
                  className="h-full bg-[#4169E1] transition-all duration-300"
                  style={{ width: `${storagePercentage}%` }}
                />
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
